module.exports = __webpack_public_path__ + "img/9.79e90f83.jpeg";